import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createProduct',
    serviceName: 'admin',
    query: gql`
      mutation createProduct(
        $title: String!
        $weight: String
        $num_in_box: String
        $unit_id: String
        $barcode: String
        $introtext: String
        $is_active: Int
        $brand_id: String
        $category_id: String
      ) {
        createProduct(
          title: $title
          weight: $weight
          num_in_box: $num_in_box
          unit_id: $unit_id
          barcode: $barcode
          introtext: $introtext
          is_active: $is_active
          brand_id: $brand_id
          category_id: $category_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
